
import Vue from "vue";
import helpers from "../inc/helpers";
import api from "../api";

import SchoolDistrictCalc from "@/data/SchoolDistrictCalc";

interface NewTax {
	index: string;
	label: string;
	cost: number;
	difference: number;
}

export default Vue.extend({
	name: "SchoolDistrictEstimateDetail",

	props: {
		parcelId: String,
	},

	data() {
		return {
			isLoading: true,
			schoolDistrictCalc: null as null | SchoolDistrictCalc,
			taxValues: {
				currentDistrict: null as null | string,
				currentCost: null as null | number,
				newTaxes: [] as Array<NewTax>,
			},
		};
	},

	mounted() {
		this.getParcelTaxValues(this.parcelId);
	},

	methods: {
		getParcelTaxValues(parcelId: string): Promise<boolean> {
			return new Promise((resolve, reject) => {
				api.getSchoolDistrictCalc(parcelId).then(
					(resp: SchoolDistrictCalc) => {
						this.schoolDistrictCalc = resp;
						this.isLoading = false;
						this.setValues();
					}
				);
			});
		},

		setValues() {
			if (!!this.schoolDistrictCalc) {
				this.taxValues.currentDistrict = this.schoolDistrictCalc.SchoolDist;

				switch (this.schoolDistrictCalc.District) {
					case "04":
					case "05":
					case "12":
					case "17":
					case "20":
					case "30":
					case "32":
						this.taxValues.currentCost =
							this.schoolDistrictCalc.PropType === "R"
								? parseFloat(this.schoolDistrictCalc.BerkCurCost)
								: parseFloat(this.schoolDistrictCalc.BerkCurCostCom);

						if (this.schoolDistrictCalc.PropType === "R") {
							this.taxValues.newTaxes.push({
								index: "a",
								label: "Berkshire Newbury Consolidated School District",
								cost: parseFloat(this.schoolDistrictCalc.BerkNewCost),
								difference:
									this.taxValues.currentCost -
									parseFloat(this.schoolDistrictCalc.BerkNewCost),
							} as NewTax);
						}

						this.taxValues.newTaxes.push({
							index:
								this.schoolDistrictCalc.PropType === "R" ? "b" : "a",
							label: "Berkshire Cardinal Consolidated School District",
							cost:
								this.schoolDistrictCalc.PropType === "R"
									? parseFloat(this.schoolDistrictCalc.BerkCardCost)
									: parseFloat(
											this.schoolDistrictCalc.BerkCardCostCom
									  ),
							difference:
								this.schoolDistrictCalc.PropType === "R"
									? parseFloat(this.schoolDistrictCalc.BerkCardDiff)
									: parseFloat(
											this.schoolDistrictCalc.BerkCardDiffCom
									  ),
						} as NewTax);

						break;
					case "06":
						this.taxValues.currentCost = parseFloat(
							this.schoolDistrictCalc.CardCurCost
						);

						this.taxValues.newTaxes.push({
							index: "a",
							label: "Berkshire Cardinal Consolidated School District",
							cost: parseFloat(this.schoolDistrictCalc.BerkCardCost),
							difference: parseFloat(
								this.schoolDistrictCalc.CardBerkDiff
							),
						} as NewTax);

						break;
					case "16":
					case "18":
					case "19":
					case "25":
					case "33":
						this.taxValues.currentCost =
							this.schoolDistrictCalc.PropType === "R"
								? parseFloat(this.schoolDistrictCalc.CardCurCost)
								: parseFloat(this.schoolDistrictCalc.CardCurCostCom);

						this.taxValues.newTaxes.push({
							index: "a",
							label: "Berkshire Cardinal Consolidated School District",
							cost: parseFloat(this.schoolDistrictCalc.BerkCardCost),
							difference: parseFloat(
								this.schoolDistrictCalc.CardBerkDiff
							),
						} as NewTax);

						break;
					case "11":
					case "22":
					case "26":
					case "27":
						this.taxValues.currentCost = parseFloat(
							this.schoolDistrictCalc.WestGCurCost
						);

						this.taxValues.newTaxes.push({
							index: "a",
							label: "West Geauga Newbury Consolidated School District",
							cost: parseFloat(this.schoolDistrictCalc.WestGNewCost),
							difference:
								this.taxValues.currentCost -
								parseFloat(this.schoolDistrictCalc.WestGNewCost),
						} as NewTax);

						break;
					case "23":
						this.taxValues.currentCost = parseFloat(
							this.schoolDistrictCalc.NewburyCurCost
						);

						this.taxValues.newTaxes.push({
							index: "a",
							label: "Berkshire Newbury Consolidated School District",
							cost: parseFloat(this.schoolDistrictCalc.BerkNewCost),
							difference: parseFloat(
								this.schoolDistrictCalc.BerkNewDiff
							),
						} as NewTax);

						this.taxValues.newTaxes.push({
							index: "b",
							label: "West Geauga Newbury Consolidated School District",
							cost: parseFloat(this.schoolDistrictCalc.WestGNewCost),
							difference: parseFloat(
								this.schoolDistrictCalc.WestGNewDiff
							),
						} as NewTax);

						break;
				}
			}
		},
	},

	computed: {},

	filters: {
		formatCurrency(val: string): string {
			return helpers.formatCurrency(val);
		},
	},

	watch: {
		parcelId() {
			this.getParcelTaxValues(this.parcelId);
		},
	},

	components: {},
});
